import * as mdiIcon from "@mdi/js"
import { moduleIcons } from "@constants/moduleIcons"

export default function getIcon(name?: string | null){
    const findIcon = moduleIcons.find(icon => icon.name === name)
    if(!!findIcon) return (mdiIcon as any)[findIcon.name]
    return mdiIcon['mdiHelp']
}